import React from 'react';
import { Alert, Box, MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const readConversationSettings = (bot = {}) => ({
    conversationMode: bot.conversationMode || 'text',
    defaultMode: bot.defaultMode || 'text',
    liveSettings: { model: 'gpt-live-1', voice: 'marin', greeting: 'Hello, how can I help you?', maxDuration: 600, ...(bot.liveSettings || {}) },
});

export const validConversationSettings = (value) => value.conversationMode === 'text' || (
    (value.liveSettings.model === 'gpt-live-1')
    && value.liveSettings.model.length <= 100
    && value.liveSettings.greeting.trim().length > 0
    && value.liveSettings.greeting.length <= 500
    && Number.isInteger(value.liveSettings.maxDuration)
    && value.liveSettings.maxDuration >= 60 && value.liveSettings.maxDuration <= 3600
);

export default function ChatbotVoiceSettings({ value, onChange, disabled = false, voiceAllowed = true }) {
    const { t } = useTranslation();
    const update = (field, next) => onChange({ ...value, [field]: next });
    const updateVoice = (field, next) => update('liveSettings', { ...value.liveSettings, [field]: next });
    return <Box sx={{ display: 'grid', gap: 2, mb: 2 }}>
        <TextField select fullWidth size="small" label={t('chatbotVoice.mode')} value={value.conversationMode}
            disabled={disabled} onChange={event => update('conversationMode', event.target.value)}>
            <MenuItem value="text">{t('chatbotVoice.text')}</MenuItem>
            <MenuItem value="voice" disabled={!voiceAllowed}>{t('chatbotVoice.voiceOnly')}</MenuItem>
            <MenuItem value="text_voice" disabled={!voiceAllowed}>{t('chatbotVoice.both')}</MenuItem>
        </TextField>
        {!voiceAllowed && <Alert severity="info">{t('chatbotVoice.unavailable')}</Alert>}
        {value.conversationMode !== 'text' && <>
            <Alert severity="info">{t('chatbotVoice.capabilities')}</Alert>
            {value.conversationMode === 'text_voice' && <TextField select fullWidth size="small"
                label={t('chatbotVoice.defaultMode')} value={value.defaultMode} disabled={disabled}
                onChange={event => update('defaultMode', event.target.value)}>
                <MenuItem value="text">{t('chatbotVoice.text')}</MenuItem>
                <MenuItem value="voice">{t('chatbotVoice.voiceOnly')}</MenuItem>
            </TextField>}
            <TextField select fullWidth size="small" label={t('chatbotVoice.voice')} value={value.liveSettings.voice}
                disabled={disabled} onChange={event => updateVoice('voice', event.target.value)}>
                {['alloy', 'ash', 'ballad', 'coral', 'echo', 'sage', 'shimmer', 'verse', 'marin', 'cedar', 'beacon', 'bossa', 'cinder', 'delta', 'gleam', 'meridian', 'quartz', 'ripple', 'stone', 'tempo', 'vesper', 'willow'].map(voice =>
                    <MenuItem key={voice} value={voice}>{voice}</MenuItem>)}
            </TextField>
            <TextField fullWidth size="small" multiline minRows={2} label={t('chatbotVoice.greeting')}
                value={value.liveSettings.greeting} disabled={disabled} inputProps={{ maxLength: 500 }}
                onChange={event => updateVoice('greeting', event.target.value)} error={!value.liveSettings.greeting.trim()} />
            <TextField fullWidth size="small" type="number" label={t('chatbotVoice.duration')}
                value={value.liveSettings.maxDuration} disabled={disabled} inputProps={{ min: 60, max: 3600, step: 1 }}
                onChange={event => updateVoice('maxDuration', Number(event.target.value))}
                error={!Number.isInteger(value.liveSettings.maxDuration) || value.liveSettings.maxDuration < 60 || value.liveSettings.maxDuration > 3600} />
        </>}
    </Box>;
}
